import { Entity } from '@backstage/catalog-model';

export const DEVLAKE_SQUAD_PREFIX = 'devlake-squad-';

export const isDevlakeSquad = (entity: Entity) =>
  entity.kind.toLowerCase() === 'component' &&
  entity.metadata.name.startsWith(DEVLAKE_SQUAD_PREFIX);

const DEVLAKE_UI_LINK_TITLE = 'DevLake UI';

export const devlakeUiUrl = (entity: Entity): string | undefined =>
  entity.metadata.links?.find(link => link.title === DEVLAKE_UI_LINK_TITLE)
    ?.url;
